/**
 * 接口域名的管理
 */
// 正式配置
// const base = {
//
//   //sq:'/api',//请求代理需要用到
//     sq:'http://wechat.nxptdn.com',
//     bd: 'http://operator.nxptdn.com',
//     client:'http://e.nxptdn.com',
//     appid:'wx9e5e67da26c51a14'
// }


//演示环境 
const base = {
  sq: '/api',//请求代理需要用到
  bd: '/api',
  // bd: 'http://localhost:9090',

  client: 'https://h5.yuyangxny.com',
  //慧知公众号
  appid: 'wxbda65adb4c5f1568'
}





export default base;


